import { DataBean } from "../DataBean";

export class UpdateManufacturing extends DataBean {



    public async updateManufacturingStardardCost(idManufacturingStardard: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_updateManufacturingStardardCost_Number", [idManufacturingStardard]);
    }

}